const listeners = new Set();
let incidents = [];

export function reportRuntimeIncident(incident) {
  const entry = {
    id: `ui-${Date.now()}-${Math.random().toString(16).slice(2, 7)}`,
    at: new Date().toISOString(),
    level: 'error',
    code: 'UI_RUNTIME',
    title: '界面运行异常',
    detail: '',
    action: '已捕获，避免影响物理仿真线程',
    ...incident,
  };
  incidents = [entry, ...incidents].slice(0, 30);
  for (const listener of listeners) {
    try {
      listener(incidents);
    } catch {
      // 日志订阅器异常不影响界面恢复。
    }
  }
  return entry;
}

export function getRuntimeIncidents() {
  return incidents;
}

export function subscribeRuntimeIncidents(listener) {
  listeners.add(listener);
  listener(incidents);
  return () => listeners.delete(listener);
}

export function clearRuntimeIncidents() {
  incidents = [];
  for (const listener of listeners) listener(incidents);
}
